import React from "react";
import styles from "./DetailList.module.less";
import { FormattedMessage } from "react-intl";
import classNames from "classnames";
export const DetailListItem = (props) => {
    const { label, children, className } = props;
    return (<div className={classNames(styles.item, className)}>
			<dt className={styles.label}>
				<FormattedMessage {...label}/>:
			</dt>
			<dd className={styles.detail}>
				{children}
			</dd>
		</div>);
};
const DetailList = ({ children, className }) => (<dl className={classNames(styles.wrapper, className)}>
		{children}
	</dl>);
export default DetailList;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/presentational/DetailList/DetailList.tsx